import React from 'react';
// import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Routes, Route, useLocation } from 'react-router-dom';

import CreateBadge from './CreateBadge';
import UserView from './Userview';
//import LandingPage from './components/LandingPage';
import Nav from './Nav/Nav';
import OverallView from './OverallView';
import Profile from './Profile/Profile';
//import SpecificBadge from './SpecificBadge';

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence
      exitBeforeEnter
      onExitComplete={() => window.scrollTo(0, 0)}
    >
      <Routes location={location} key={location.pathname}>
        <Route path='/create' element={<CreateBadge />} />

        <Route path='/overallview' element={<OverallView />} />
        
        
        
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
